import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router';

export default function MetrcCards({ listData, integrationid }) {
  const navigate = useNavigate();
  // const { integrationid } = useParams();
  const handleCardClick = tabs => {
    const formattedTab = tabs.replace(/\s+/g, '-').toLowerCase();
    console.log('formatted tab', formattedTab);
    navigate(`/integration/${integrationid}/${formattedTab}`);
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
      {listData?.map((entry, index) => (
        <Card
          key={index}
          sx={{
            width: '32.5%', // Adjust width to make space for two cards in a row
            backgroundColor: '#303130',
            color: '#B1D23A',
            borderBottom: '3px solid #B1D23A', // Only set bottom border
            boxShadow: 'none',
            height: '200px',
            cursor: 'pointer',
          }}
          onClick={() => handleCardClick(entry.name.toLowerCase())}
        >
          <CardContent>
            <Typography gutterBottom sx={{ color: 'inherit', fontSize: 14 }}>
              {entry.title}
            </Typography>
            <Typography variant="h5" component="div" sx={{ color: 'inherit' }}>
              {entry.name || 'N/A'}
            </Typography>
            <Typography sx={{ color: 'inherit', mb: 1.5 }}>Description: {entry.description || 'No description available.'}</Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
